export default __webpack_public_path__ + "static/media/brindavan gardens.8b2b7a91.jpg";